import React from 'react';
import { ImmutableEntity, type TaxonomyEntity } from '@uncinc/react-drupal-core/types';
import Immutable from 'immutable';

import ViewNestedTaxonomiesComplex from './Complex';
import ViewNestedTaxonomiesSimple from './Simple';
import ViewNestedTaxonomiesTargetAudiences from './TargetAudiences';

type NestedTaxonomiesViewListType = 'simple' | 'complex';

export interface ViewNestedTaxonomiesProps {
  entities: Immutable.List<ImmutableEntity<TaxonomyEntity>>;
  listType: NestedTaxonomiesViewListType;
  taxonomyType?: string;
  title?: string;
}

const ViewNestedTaxonomies: React.FC<ViewNestedTaxonomiesProps> = (props) => {
  const {
    entities,
    listType,
    taxonomyType,
    title,
  } = props;

  if (taxonomyType === 'target_audiences') {
    return (
      <ViewNestedTaxonomiesTargetAudiences entities={entities} title={title} />
    );
  }

  switch (listType) {
    case 'simple':
      return <ViewNestedTaxonomiesSimple entities={entities} />;
    case 'complex':
    default:
      return <ViewNestedTaxonomiesComplex entities={entities} title={title} />;
  }
};

export default ViewNestedTaxonomies;
